import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed w-full top-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-black/80 backdrop-blur-md shadow-md" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-yellow-400">Kwame O. Sarfo</h1>

        {/* Hamburger Menu for mobile */}
        <div className="md:hidden flex items-center">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-white focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
        </div>

        {/* Desktop Menu */}
        <nav className="space-x-8 hidden md:flex">
          <Link
            to="/"
            className="text-white hover:text-yellow-400 transition duration-300"
          >
            Home
          </Link>
          <Link
            to="/about"
            className="text-white hover:text-yellow-400 transition duration-300"
          >
            About
          </Link>
          <Link
            to="/ventures"
            className="text-white hover:text-yellow-400 transition duration-300"
          >
            Ventures
          </Link>
          <Link
            to="/contact"
            className="text-white hover:text-yellow-400 transition duration-300"
          >
            Contact
          </Link>
        </nav>

        {/* Mobile Menu */}
        <nav
          className={`${
            menuOpen ? "block" : "hidden"
          } absolute top-0 left-0 w-full bg-black bg-opacity-90 p-4 md:hidden`}
        >
          <Link
            to="/"
            className="block text-white py-2 px-4 hover:text-yellow-400 transition duration-300"
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/about"
            className="block text-white py-2 px-4 hover:text-yellow-400 transition duration-300"
            onClick={() => setMenuOpen(false)}
          >
            About
          </Link>
          <Link
            to="/ventures"
            className="block text-white py-2 px-4 hover:text-yellow-400 transition duration-300"
            onClick={() => setMenuOpen(false)}
          >
            Ventures
          </Link>
          <Link
            to="/contact"
            className="block text-white py-2 px-4 hover:text-yellow-400 transition duration-300"
            onClick={() => setMenuOpen(false)}
          >
            Contact
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
